
import * as React from "react"
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area"
import { cn } from "@/lib/utils"
import { ScrollBarThumb } from "./ScrollBarThumb"

const ScrollBar = React.forwardRef<
  React.ElementRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>,
  React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>
>(({ className, orientation = "vertical", ...props }, ref) => (
  <ScrollAreaPrimitive.ScrollAreaScrollbar
    ref={ref}
    orientation={orientation}
    className={cn(
      "flex touch-none select-none transition-colors",
      orientation === "vertical" && "h-full w-2.5 right-1",
      orientation === "horizontal" && "h-2.5 bottom-1",
      "bg-transparent hover:bg-black/5 dark:hover:bg-white/5",
      "rounded-full",
      "border-none",
      "opacity-40 group-hover:opacity-90",
      "transition-all duration-300 ease-in-out",
      className
    )}
    {...props}
  >
    <ScrollBarThumb />
  </ScrollAreaPrimitive.ScrollAreaScrollbar>
))
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName

export { ScrollBar }
